import { useState, useEffect, useCallback } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';

import { useWorkspace } from '@mssgme/hooks';
import { resolvePathname } from '@mssgme/helpers';
import { useEventEmitter } from '@mssgme/ui';

export default function useQuickReplyList() {
    const workspace = useWorkspace();
    const history = useHistory();
    const { url } = useRouteMatch();
    const [redirectTo, setRedirectTo] = useState();
    const ee = useEventEmitter();

    useEffect(() => {
        if (redirectTo) {
            history.push(redirectTo);
        }
    }, [redirectTo]);

    const items = workspace.replies;

    const onClose = () => setRedirectTo(resolvePathname(url, '..'));

    const onSelectItem = useCallback(({ message }) => {
        ee.emit('inbox:replySelect', message);
    }, []);

    return {
        items,
        onClose,
        onSelectItem,
    };
}
